export default __webpack_public_path__ + "static/media/sd_footer_logo.87dcd951.svg";